
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_1ijks_94",
  "header": "awsui_header_l0dv0_1ijks_108",
  "header-link": "awsui_header-link_l0dv0_1ijks_113",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_1ijks_123",
  "header-link-text": "awsui_header-link-text_l0dv0_1ijks_123",
  "header-logo": "awsui_header-logo_l0dv0_1ijks_127",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_1ijks_133",
  "list-container": "awsui_list-container_l0dv0_1ijks_138",
  "list": "awsui_list_l0dv0_1ijks_138",
  "list-variant-root": "awsui_list-variant-root_l0dv0_1ijks_148",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_1ijks_154",
  "list-item": "awsui_list-item_l0dv0_1ijks_158",
  "section": "awsui_section_l0dv0_1ijks_164",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_1ijks_165",
  "section-header": "awsui_section-header_l0dv0_1ijks_178",
  "link": "awsui_link_l0dv0_1ijks_183",
  "link-active": "awsui_link-active_l0dv0_1ijks_190",
  "info": "awsui_info_l0dv0_1ijks_224",
  "external-icon": "awsui_external-icon_l0dv0_1ijks_228",
  "divider": "awsui_divider_l0dv0_1ijks_232",
  "divider-default": "awsui_divider-default_l0dv0_1ijks_237",
  "divider-header": "awsui_divider-header_l0dv0_1ijks_241"
};
  